import React from "react";
import { Description, LanguageOutlined, TextFields } from "@mui/icons-material";
import MultiLangForm from "../../../../../../components/form/MultiLangForm";
import ChipTabs from "../../../../../../components/ChipsTabs";
import { useParams } from "react-router-dom";
import { INFORMATION_FIELD_REQUEST } from "../../../../../../enums/ApiPaths";
import InformationFieldEditingForm from "./InformationFieldEditingForm";
import { ABOUT_US, INFO_FIELD } from "../../../../../../enums/QueryKeys";

export default function InformationFieldChipsTab({ informationField }) {
  const { id: clinicId } = useParams();
  const editPath = INFORMATION_FIELD_REQUEST + clinicId;
  const icons = [<TextFields />, <LanguageOutlined />, <Description />];
  const tabContent = [
    <InformationFieldEditingForm informationField={informationField} />,
    <MultiLangForm
      invalidationKeys={[ABOUT_US]}
      mutationKey={[INFO_FIELD]}
      key={"labelTranslation" + informationField?.id}
      translationTarget="labelTranslation"
      btnMsg={"Save"}
      testId={`clinic.info-fields.item.${informationField?.id}.label-translation`}
      object={informationField}
      maxLength={50}
      postUrl={editPath}
    />,
    <MultiLangForm
      invalidationKeys={[ABOUT_US]}
      mutationKey={[INFO_FIELD]}
      key={"fieldValueTranslation" + informationField?.id}
      btnMsg={"Save"}
      translationTarget="fieldValueTranslation"
      testId={`clinic.info-fields.item.${informationField?.id}.value-translation`}
      object={informationField}
      maxLength={70}
      postUrl={editPath}
    />,
  ];
  const tabLabels = ["Edit", "LabelTranslation", "FieldValueTranslation"];
  return ( 
    <ChipTabs
      lsKey={"INFORMATION_FIELDS_LS_KEY"}
      icons={icons}
      tabContent={tabContent}
      tabLabels={tabLabels}
      wrapperMaxWidth="85vw"
      tabTestIds={[
        `clinic.info-fields.item.${informationField?.id}.edit-tab`,
        `clinic.info-fields.item.${informationField?.id}.label-translation-tab`,
        `clinic.info-fields.item.${informationField?.id}.value-translation-tab`,
      ]}
    />
  );
}
